import type { Translated } from '@uefadigital/panenka';
import clsx from 'clsx';
import { memo, useMemo } from 'react';

import { hydrateWithTranslations } from '@services/TranslatorService';
import { useWindowSize } from '@shared/hooks/useWindowSize';
import QualifiedIndicator from '@shared/QualifiedIndicator';
import { useTranslateFn } from '@shared/Translate';
import type { QualificationLabel } from '@shared-types/standing.types';
import { legendConfig } from '@utilities/standings';

import * as classes from '../styles.module.scss';

const columnsLegend = ['played', 'goal_difference', 'points', 'recent_results'] as const;

const Legend = ({ someQualified, labels }: { someQualified: boolean; labels: QualificationLabel[] }) => {
  const t = useTranslateFn();
  const { isMobile } = useWindowSize();

  const positionLegend = useMemo<Translated<QualificationLabel>[]>(
    () =>
      Array.from(legendConfig.keys())
        .map((l) => hydrateWithTranslations(labels?.find((label) => label.labelId === l)))
        .filter(Boolean),
    [labels],
  );
  const showLegend = someQualified && !!positionLegend.length;

  if (!showLegend && !isMobile) return null;

  return (
    <div className='pk-d--flex pk-gap--s pk-pt--s pk-font-size--xs pk-text--text-02'>
      {showLegend && (
        <div className={clsx(classes.newFormatLegend, 'pk-d-sm--flex pk-gap--s pk-gap-sm--xl')}>
          {positionLegend.map(({ labelName, labelId }) => (
            <div key={labelId} className='pk-d--flex pk-align-items--center pk-justify-content--start pk-gap--xs2'>
              <QualifiedIndicator type='dot' labelId={labelId} />
              {labelName}
            </div>
          ))}
        </div>
      )}
      {isMobile && (
        <div className={clsx(classes.newFormatLegend, !someQualified && classes.newFormatLegendSingle, 'pk-gap--s')}>
          {columnsLegend.map((item) => (
            <div key={item} className='pk-d--flex pk-align-items--start pk-justify-content--start pk-gap--xs2'>
              <span className='pk-font--base-semibold pk-text--text-01'>{t(`${item}_abbr`)}</span>
              {t(item)}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default memo(Legend);
